import { putMethod } from "./httpMethods";
export const updateUser = (data) => {
  // alert(JSON.stringify(data))
  return new Promise((resolve, reject) => {
    putMethod(`user/${data.id}`, data.payload)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const updateTeamBasedMember = (competitionId, payload) => {
  return new Promise((resolve, reject) => {
    putMethod(
      `competition/team-based/${competitionId}/participant/change-status`,
      payload
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const updateChampionRank = (id, payload) => {
  return new Promise((resolve, reject) => {
    putMethod(`competition/team-based/simoc/${id}/champion/rank`, payload)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
